"use client";

import { useSession } from "@/components/SupabaseProvider";
import { useQuery } from "@tanstack/react-query";
import { PlanType } from "../const/planConst";

// For getting the preview/upcoming invoice
export const useSubscriptionUpcoming = (plan: PlanType) => {
  const session = useSession();

  return useQuery({
    queryKey: ["subscription-preview", plan],
    queryFn: async () => {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}/billing/subscription/upcoming/${plan}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${session?.access_token}`,
          },
        }
      );

      if (!res.ok) {
        throw new Error(`Something went wrong (status ${res.status})`);
      }
      return res.json();
    },
    enabled: !!session,
    retry: false,
  });
};
